import { inject } from "@angular/core";
import { createEffect, Actions, ofType } from "@ngrx/effects";
import { cameraActions } from "../camera/camera.actions";
import { Store } from "@ngrx/store";
import { ChatActions } from "./chatActions";
import { switchMap, combineLatest, filter, map, withLatestFrom } from "rxjs";
import { Vector3 } from "three/src/math/Vector3.js";
import { EventsWebsocketService } from "../../services/entities/events-websocket.service";
import { entityActions } from "../entities/entity.actions";
import { generateUUID } from "three/src/math/MathUtils.js";
import { CollisionType, Components, EntityType } from "../entities/entity.model";
import { LookingAtProperties } from "../entities/component-properties-dto/looking-at.properties.dto";
import { selectUserAvatarId } from "../auth/auth.selector";
import {UsersService} from "../../services/users.service";
import {ChatsService} from "../../services/chats.service";


export const newChat = createEffect(
  (
      actions$ = inject(Actions),
      chatService = inject(ChatsService)
  ) => {
    return actions$.pipe(
      ofType(ChatActions.newChat),
      map(async (action) => {
        await chatService.newChat(action.name, action.ownerId, action.participants)
      }),
    );
  },
  { functional: true, dispatch: false },
);


export const newMessage = createEffect(
    (
        actions$ = inject(Actions),
        chatService = inject(ChatsService)
    ) => {
      return actions$.pipe(
          ofType(ChatActions.newMessage),
          map(async (action) => {
            await chatService.newMessage(
                action.chatId,
                action.text,
                action.ownerId,
                action.components,
                action.componentProperties
            )
          }),
      );
    },
    { functional: true, dispatch: false },
);


export const updateLastSeen = createEffect(
    (
        actions$ = inject(Actions),
        chatService = inject(ChatsService)
    ) => {
        return actions$.pipe(
            ofType(ChatActions.updateLastSeen),
            map(async (action) => {
                await chatService.updateLastSeen(
                    action.chatId,
                    action.userId
                )
            }),
        );
    },
    { functional: true, dispatch: false },
);
